// src/pages/OfferPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

async function apiGet(url){
  const r = await fetch(url, { credentials:"include" });
  const j = await r.json().catch(async()=>({ success:false, message: await r.text() }));
  if (!r.ok || !j.success) throw new Error(j.message || `HTTP ${r.status}`);
  return j;
}



export default function OfferPage(){
  const { code } = useParams();
  const [bundle, setBundle] = useState(null);
  const [offerFiles, setOfferFiles] = useState([]);
  const [docs, setDocs] = useState([]);
  const [models, setModels] = useState([]);

  useEffect(()=>{
    (async()=>{
      const b = await apiGet(`https://modularobjects.com/marketing/api/offer/${code}`);
      setBundle(b);

      // hit
      fetch(`https://modularobjects.com/marketing/api/offer/${code}/hit`, { method:"POST", credentials:"include" }).catch(()=>{});

      const of = await apiGet(`https://modularobjects.com/marketing/api/offer/${code}/files?dir=offer`);
      const df = await apiGet(`https://modularobjects.com/marketing/api/offer/${code}/files?dir=docs`);
      const mf = await apiGet(`https://modularobjects.com/marketing/api/offer/${code}/files?dir=models`);

      setOfferFiles(of.items || []);
      setDocs(df.items || []);
      setModels(mf.items || []);
    })().catch(console.error);
  }, [code]);

  if (!bundle) return <div className="p-6">Loading…</div>;

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6">
      <div className="border rounded-lg p-4">
        <div className="text-sm text-gray-500">Offer code</div>
        <div className="text-xl font-semibold">{bundle.token.code}</div>
        {bundle.opportunity && (
          <div className="text-sm mt-2">
            <b>{bundle.opportunity.name}</b> • {bundle.opportunity.account}
          </div>
        )}
      </div>

      {/* Offer PDF */}
      <div className="border rounded-lg p-4">
        <div className="font-medium mb-2">Offer</div>
        {offerFiles.length ? (
          <iframe
            title="offer"
            src={offerFiles[0].url}
            className="w-full h-[70vh] rounded border"
          />
        ) : (
          <div className="text-sm text-gray-500">Nema još ponude (upload u /offer folder).</div>
        )}
      </div>

      {/* Docs */}
      <div className="border rounded-lg p-4">
        <div className="font-medium mb-2">Documents</div>
        <ul className="text-sm list-disc pl-5">
          {docs.map(f => <li key={f.url}><a className="underline" href={f.url} target="_blank" rel="noreferrer">{f.name}</a></li>)}
          {!docs.length && <li className="text-gray-500 list-none">Nema dokumenata.</li>}
        </ul>
      </div>

      {/* Models */}
      <div className="border rounded-lg p-4">
        <div className="font-medium mb-2">3D Models</div>
        <ul className="text-sm list-disc pl-5">
          {models.map(f => <li key={f.url}><a className="underline" href={f.url} target="_blank" rel="noreferrer">{f.name}</a></li>)}
          {!models.length && <li className="text-gray-500 list-none">Nema modela.</li>}
        </ul>
        {/* sledeće: ubacimo tvoj 3D viewer i auto-load .glb */}
      </div>
    </div>
  );
}